import { createAction } from '@reduxjs/toolkit';
import { Profile } from './types';

export const hydrateProfile = createAction<Profile>('profile/hydrate');
